var ui_templates = require("ui-templates");

var TooltipView = function (model, theme) {
    var self =  this;
    this.model = model;
    this.theme = theme;

    // OBSERVERS
    this.model.visible.onChange(this, function(value){
        if(value){
            self.showTooltip();
        }else{
            self.hideTooltip();
        }
    });

    this.model.title.onChange(this, function(value){
        self.setTooltipTitle(value);
    });

    this.model.position.onChange(this, function(value){
        self.setPos(value.x, value.y);
    });

    this.model.direction.onChange(this, function(value){
        self.setDirection(value);
    });
};

module.exports = TooltipView;

TooltipView.prototype.getTemplate = function () {
    if(!this._template){
        this._template = new ui_templates.Tooltip();
    }
    return this._template;
};

TooltipView.prototype.showTooltip = function () {
    this.getTemplate().show();
};

TooltipView.prototype.hideTooltip = function () {
    this.getTemplate().hide();
};

TooltipView.prototype.setTooltipTitle = function (title) {
    this.getTemplate().setTitle(title);
};

TooltipView.prototype.setPos = function (x, y) {
    this.getTemplate().setPos(x, y);
};

TooltipView.prototype.setDirection = function (direction) {
    this.getTemplate().setDirection(direction);
};
